import { RouteConfig } from "vue-router";

export const RCandidateTemplateOnlineApplication: RouteConfig = {
  path: "online_application/:tabTypeId(\\d+)",
  name: "CandidateOnlineApplication",
  component: () =>
    import(
      /* webpackChunkName: "candidate-template-online-application" */
      "./VTemplateOnlineApplication.vue"
    ),
  meta: {
    label: "online application",
    tabName: "online_application",
  },
};

export const RExpertTemplateOnlineApplication: RouteConfig = {
  path: "online_application/:tabTypeId(\\d+)",
  component: () =>
    import(
      /* webpackChunkName: "expert-template-online-application" */
      "./VTemplateOnlineApplication.vue"
    ),
  meta: {
    label: "online application",
    tabName: "online_application",
  },
};
